/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
// import ImagePlaceholder from 'assets/img/image-placeholder.jpg';
// import SecuredImage from 'modules/common/components/SecuredImage';
import DateInputPicker from 'modules/common/components/DateInputPicker';
import * as action from '../action';
import * as c from '../constant';

function UpdateModal({
  profile,
  setFormData,
  formData,
  createUpperCaseInput,
  updateBirthCertificate,
  syncToEs,
  getBirthCertificateList,
  showBirthCertificate,
  history,
  updating,
  syncing,
}) {
  const setModal = useContext(ModalContext);

  const OnSetFormData = () => {
    setFormData({
      registry_number: profile.attributes.registry_number || '',
      first_name: profile.attributes.first_name || '',
      last_name: profile.attributes.last_name || '',
      middle_name: profile.attributes.middle_name || '',
      death_date: profile.attributes.death_date || '',
      volume: profile.attributes.volume || '',
      fatal: profile.attributes.fatal || '',
      // front_page: profile.attributes.front_page || '',
      // back_page: profile.attributes.back_page || '',
    });
  };

  // const onUpload = (side) => (e) => {
  //   e.preventDefault();

  //   const reader = new FileReader();
  //   const file = e.target.files[0];

  //   reader.onloadend = () => {
  //     setFormData({
  //       ...formData,
  //       [`${side}`]: reader.result,
  //       [`${side}_file`]: file,
  //     });
  //   };

  //   reader.readAsDataURL(file);
  // };

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const args = {
      ...formData
    }

    args.first_name = args.first_name.toUpperCase();
    args.last_name = args.last_name.toUpperCase();
    args.middle_name = args.middle_name.toUpperCase();

    updateBirthCertificate(profile.id, args, ({ data }) => {
      getBirthCertificateList();
      setModal({ isOpen: false });
      showBirthCertificate(profile.id);
      syncToEs({ id: profile.id });
      history.push(
        `/civil-registry/death-certificate/records-maintenance/${_.get(
          data,
          'id'
        )}`
      );
      // UpdateInfo();
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const handleOnChangeDate = (key) => ({ target: { value } }) => {
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(profile)) {
      OnSetFormData();
    }
  }, [profile]);

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="">Document&apos;s Owner Personal Information</div>
        <div className="border border-primary row m-1 p-1">
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'registry_number', label: 'Registry Number:' },
              { required: true, placeholder: 'registry_number' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'last_name', label: 'Last Name:' },
              { required: true, placeholder: 'Last Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'middle_name', label: 'Middle Name:' },
              { required: false, placeholder: 'Middle Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'first_name', label: 'First Name' },
              { required: true, placeholder: 'First Name' }
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'volume', label: 'Volume' },
              { required: true, placeholder: 'volume'}
            )}
          </div>
          <div className="col-3 form-group">
            {createUpperCaseInput(
              { key: 'fatal', label: 'Fatal' },
              { required: true, placeholder: 'fatal' }
            )}
          </div>

          <div className="col-3 form-group">
            <label className="form-control-plaintext form-label">
              Date of Death:
              <span className="text-danger">
                <i>Required</i>
              </span>
            </label>
            <DateInputPicker
              className="full-input"
              onChange={handleOnChangeDate('death_date')}
              value={_.get(formData, 'death_date') || ''}
              maxDate={new Date()}
            />
          </div>
        </div>
        {/* <div className="">Death Certificates</div>
        <div className="border border-primary row m-1 p-1">
          <div className="col-md-6">
            <label>Front</label>
            <div className="col-12 bc-image ">
              <SecuredImage
                onContextMenu={(e) => {
                  e.preventDefault();
                  return false;
                }}
                alt="BC"
                src={_.get(formData, 'front_page') || ImagePlaceholder}
              />
            </div>
            <div className="col-12 ">
              <input
                style={{ width: '100%' }}
                type="file"
                className="btn border border-primary btn-light btn-round font-weight-bold px-4 ml-auto"
                onChange={onUpload('front_page')}
              />
            </div>
          </div>
          <div className="col-md-6">
            <label>Back</label>
            <div className="col-12 bc-image ">
              <SecuredImage
                onContextMenu={(e) => {
                  e.preventDefault();
                  return false;
                }}
                alt="BC"
                src={_.get(formData, 'back_page') || ImagePlaceholder}
              />
            </div>
            <div className="col-12 ">
              <input
                style={{ width: '100%' }}
                type="file"
                className="btn border border-primary btn-light btn-round font-weight-bold px-4 ml-auto"
                onChange={onUpload('back_page')}
              />
            </div>
          </div>
        </div> */}

        <div className="d-flex justify-content-center">
          <button
            disabled={updating || syncing}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">
              {updating || syncing ? (
                <i className="fa fa-spin fa-spinner" />
              ) : (
                `Submit`
              )}
            </span>
          </button>
          <button
            disabled={updating || syncing}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  profile: PropTypes.instanceOf(Object).isRequired,
  updateBirthCertificate: PropTypes.instanceOf(Function).isRequired,
  syncToEs: PropTypes.instanceOf(Function).isRequired,
  getBirthCertificateList: PropTypes.instanceOf(Function).isRequired,
  showBirthCertificate: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  createUpperCaseInput: PropTypes.instanceOf(Function).isRequired,
  updating: PropTypes.bool.isRequired,
  syncing: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  profile: _.get(api, `${c.GET_SINGLE_USER_MANAGEMENT}.item`) || {},
  roleList: _.get(api, `${c.GET_ROLE_LIST}.list`) || [],
  updating: api.loading.indexOf(c.UPDATE_USER_MANAGEMENT) > -1,
  syncing: api.loading.indexOf(c.SYNC_TO_ES) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, action),
]);

export default enhance(UpdateModal);
